import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  text: {
    color: theme.palette.text.secondary,
  },
  infoIcon: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'help',
    color: theme.palette.text.secondary,
  },
  list: {
    margin: 0,
    paddingLeft: theme.spacing(2),
  },
}))

export default useStyles
